const configuration: Record<string, string | undefined> = {
  ENV: import.meta.env?.MODE,
  PAYPER_BACKEND_BASE_ROUTE: import.meta.env.VITE_PAYPER_BACKEND_BASE_ROUTE,
  PAYPER_WEB_BASE_ROUTE: import.meta.env.VITE_PAYPER_WEB_BASE_ROUTE,
  PAYPER_MAGIC_BROWSE_ROUTE: import.meta.env.VITE_PAYPER_MAGIC_BROWSE_ROUTE,
  PAYPER_EVENTS_ENDPOINT: import.meta.env.VITE_PAYPER_EVENTS_ENDPOINT,
}

// NOTE: Do not transform to an arrowFunction - Typescript cannot use arrowFunctions for assertions: https://github.com/microsoft/TypeScript/issues/34523
function validateEnvVars(
  configuration: Record<string, string | undefined>,
): asserts configuration is Record<string, string> {
  for (const [key, value] of Object.entries(configuration)) {
    if (value === undefined) {
      throw Error(
        `Error in env vars configuration at Payper Reading Bar: the env var \'${key}\' must be provided`,
      )
    }
  }
}

validateEnvVars(configuration)

export default configuration
